// src/components/CaretLi.jsx
import React from "react";
import caretIcon from "../assets/icons/CaretCircleRight.svg";
import caretIconLight from "../assets/icons/CaretCircleRightLight.svg";

const CaretLi = ({ children }) => {
  return (
    <li className="flex items-center gap-2">
      {/* Light mode */}
      <img
        src={caretIconLight}
        alt="Caret"
        className="w-4 h-4 flex-shrink-0 dark:hidden"
      />

      {/* Dark mode */}
      <img
        src={caretIcon}
        alt="Caret"
        className="w-4 h-4 flex-shrink-0 hidden dark:block"
      />

      <span className="text-[16px] font-normal">{children}</span>
    </li>
  );
};

export default CaretLi;
